<script>
	import { fade } from 'svelte/transition';
	import { scaleAdOnHover, startAd, pauseAd, stopAd } from '../../../../share/ads';
	import { getText } from '../../../../share/utils';

	let ads = {
		// Scheinwerferleuchten_K
		scheinwerfer: {
			element: false,
			fallbackImgUrl: './../video/Scheinwerferleuchten_K_Poster.webp',
			imageAltText: 'BurgEins stromert - Scheinwerferleuchten - interactive Ad',
			videoUrl: './../video/Scheinwerferleuchten_K.mp4',
			playTimeMs: 15000,
			playing: false,
			autoStopTimeOut: false,
			pauseImgOffsetS: 4,
			volume: 0,
			showPauseButton: false,
			scale: 1,
			origWidth: 670,
			origHeight: 670
		},
		// driving_home
		driving: {
			element: false,
			fallbackImgUrl: './../video/driving_home_Poster.webp',
			imageAltText: 'BurgEins stromert - driving home - interactive Ad',
			videoUrl: './../video/driving_home.mp4',
			playTimeMs: 16000,
			playing: false,
			autoStopTimeOut: false,
			pauseImgOffsetS: 6,
			volume: 0,
			showPauseButton: false,
			scale: 1,
			origWidth: 670,
			origHeight: 670
		},
		// driving_home
		handy: {
			element: false,
			fallbackImgUrl: './../video/600x1299-K.webp',
			videoUrl: './../video/klima_9-16.mp4',
			playTimeMs: 15000,
			playing: false,
			autoStopTimeOut: false,
			pauseImgOffsetS: 14,
			volume: 0,
			showPauseButton: false,
			scale: 1,
			origWidth: 278,
			origHeight: 496
		}
	}
</script>

<div class="page-energy-advent marginbox">
	<div class="img-single">
		<img loading="lazy" alt="umschalten.de - Netz-Ad" src="./../img/18.BurgEins_Stromert/02.advent/netz.webp">
	</div>
	
	<div class="flex structure">
		<div class="flex row structure-1">
			<div class="flex element">
				<!-- Beginning - scheinwerfer -->
				<div bind:this={ads.scheinwerfer.element} class="flex element">
					<div use:scaleAdOnHover={ads.scheinwerfer} class="commercial" class:playing={ads.scheinwerfer.playing}
						 on:click={() => !ads.scheinwerfer.playing ? startAd(ads.scheinwerfer, () => ads = ads) : null}>
						<video playsinline loop="true"
							   on:loadeddata={() => stopAd(ads.scheinwerfer, () => ads = ads)}
							   on:mousemove={() => {ads.scheinwerfer.showPauseButton = true; setTimeout(() => {
								   ads.scheinwerfer.showPauseButton = false;
							   }, 2000)}}
							   scrolling="no"
							   src={ads.scheinwerfer.videoUrl}
						/>
						{#if ads.scheinwerfer.playing}
							<!-- PLAYING -->
							{#if ads.scheinwerfer.showPauseButton}
								<button aria-label="pause Ad - {ads.scheinwerfer.imageAltText}" transition:fade class="pausebutton"
										on:click={() => pauseAd(ads.scheinwerfer, () => ads = ads)}></button>
							{/if}
						{:else}
							<!-- NOT PLAYING -->
							<button aria-label="play Ad - {ads.scheinwerfer.imageAltText}" class="playbutton"></button>
						{/if}
					</div>
				</div>
				<!-- End - scheinwerfer -->
			</div>
			
			<div class="flex element">
				<!-- Beginning - driving -->
				<div bind:this={ads.driving.element} class="flex element">
					<div use:scaleAdOnHover={ads.driving} class="commercial" class:playing={ads.driving.playing}
						 on:click={() => !ads.driving.playing ? startAd(ads.driving, () => ads = ads) : null}>
						<video playsinline loop="true"
							   on:loadeddata={() => stopAd(ads.driving, () => ads = ads)}
							   on:mousemove={() => {ads.driving.showPauseButton = true; setTimeout(() => {
								   ads.driving.showPauseButton = false;
							   }, 2000)}}
							   scrolling="no"
							   src={ads.driving.videoUrl}
						/>
						{#if ads.driving.playing}
							<!-- PLAYING -->
							{#if ads.driving.showPauseButton}
								<button aria-label="pause Ad - {ads.driving.imageAltText}" transition:fade class="pausebutton"
										on:click={() => pauseAd(ads.driving, () => ads = ads)}></button>
							{/if}
						{:else}
							<!-- NOT PLAYING -->
							<button aria-label="play Ad - {ads.driving.imageAltText}" class="playbutton"></button>
						{/if}
					</div>
				</div>
				<!-- End - driving -->
			</div>
		</div>
		
		<div class="flex col structure-2">
			<div class="flex element">
				<img loading="lazy" alt="so-geht-e.de - mobile-Ad" src="./../img/18.BurgEins_Stromert/02.advent/Gruppe386.webp">
				<!-- Beginning - driving -->
				<div bind:this={ads.handy.element} class="flex element overlay">
					<div use:scaleAdOnHover={ads.handy} class="commercial"
						 class:playing={ads.handy.playing}
					on:click={() =>
					!ads.handy.playing ? startAd(ads.handy, () => ads = ads) : null}>
						<video playsinline loop="true"
							   on:loadeddata={() => stopAd(ads.handy, () => ads = ads)}
							   on:mousemove={() => {ads.handy.showPauseButton = true; setTimeout(() => {
								   ads.handy.showPauseButton = false;
							   }, 2000)}}
							   scrolling="no"
							   src={ads.handy.videoUrl}
						/>
						{#if ads.handy.playing}
							<!-- PLAYING -->
							{#if ads.handy.showPauseButton}
								<button aria-label="pause Ad - {ads.handy.imageAltText}" transition:fade class="pausebutton"
										on:click={() => pauseAd(ads.handy, () => ads = ads)}></button>
							{/if}
						{:else}
							<!-- NOT PLAYING -->
							<button aria-label="play Ad - {ads.handy.imageAltText}" class="playbutton"></button>
						{/if}
					</div>
				</div>
				<img class="empty" loading="lazy" alt="so-geht-e.de - mobile-Ad"
					 src="./../img/18.BurgEins_Stromert/02.advent/Gruppe386_empty.webp">
				<!-- End - driving -->
			</div>
			
			<div class="flex element">
				<div class="text">
					<h2>{getText("18.02.01_h2")}</h2>
					<p class="caption">{getText("18.02.02_caption")}</p>
				</div>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.img-single {
		margin: $spacing-mobile 0 $media-gap 0;
		line-height: 0;
	}
	
	.page-energy-advent {
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		
		.content {
			flex: 1 100%;
		}
		
		.structure {
			flex-flow: row wrap;
		}
		
		.structure-1,
		.structure-2 {
			@include for-tablet-portrait-up {
				flex-flow: row nowrap;
			}
		}
		
		.structure-1 {
			width: 100%;
			gap: $media-gap;
			padding: 0;
			margin-bottom: $media-gap;
			
			.element {
				width: 100%;
				height: fit-content;
				line-height: 0;
			}
		}
		
		.structure-2 {
			width: 100%;
			padding: 0;

			@include for-tablet-portrait-up {
				width: 60%;
			}
			
			@include for-tablet-landscape-up {
				width: 80%;
			}
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
				position: relative;
			}
			
			.element:first-of-type {
				@include for-tablet-portrait-up {
					width: 30%;
				}
			}
			
			.element:last-of-type {
				@include for-tablet-portrait-up {
					width: 60%;
				}
			}

			.overlay {
				position: absolute;
				width: 100% !important;
				height: 100%;

				img, video {
					position: absolute;
				}

				video {
					width: 89%;
					position: relative;
				}

				:global(.greyOverlay) {
					top: 50%;
					transform: translateY(-50%);
					width: 89%;
					left: 5.5%;
				}
			}

			img.empty {
				position: absolute;
				pointer-events: none;
			}
		}
		
		.structure-3 {
			width: 100%;
			margin-bottom: $media-gap;
			padding: 0;
			position: relative;
			
			.element:first-of-type {
				width: 90%;
				height: fit-content;
				margin-top: 50px;
			}
			
			.element:nth-of-type(2) {
				width: 40%;
				height: fit-content;
				position: absolute;
				top: 0;
				right: 0;
			}
		}

		.text {
			margin: 0;

			@include for-tablet-portrait-up {
				margin-left: $media-gap;
			}
		}

		.commercial video {
			width: 100%;
			height: calc(var(--origHeight) * var(--scale));
			background-image: var(--bg-image);
			background-size: cover;
		}

		:global(.commercial video[loaded]) {
			background-image: none !important;
		}
	}
</style>
